// billing-plugin/common/schemas/collections/chargeRecords.js
import { z } from "zod";

const ChargeRecordSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    targetId: z.string().describe("The subscriptionId or userId."),
    
    amount: z.number().int().describe("The charge amount in cents (negative for charges, positive for credits/payments)."),
    currency: z.string().length(3),
    description: z.string(),
    
    type: z.enum(['usage', 'recurring', 'one-time', 'recharge', 'refund', 'credit', 'proration', 'discount']),
    
    // --- NEW FIELDS FOR AUDIT TRAIL ---
    chargeableId: z.string().optional().nullable().describe("The _id of the associated chargeable record, if applicable."),
    lineItemId: z.string().optional().nullable().describe("The featureKey of the line item this charge relates to."),
    entityId: z.string().optional().nullable().describe("The ID of the specific entity being billed (e.g., userId, channelConfigId)."),
    // --- END NEW FIELDS ---

    invoiceId: z.string().optional().nullable(),
    paymentTransactionId: z.string().optional().nullable(),
    
    createdAt: z.coerce.date(),
});

export default ChargeRecordSchema;